import * as React from 'react'

import withStatusSubscription from '../../../../../hocs/withStatusSubscription'
import type {BuildTypeId, ProjectId} from '../../../../../types'

type Props = {
  buildTypeId: BuildTypeId | null | undefined
  projectId: ProjectId | null | undefined
  subscribeDelayMS?: number
  updateOverviewParents?: boolean
  withoutBranch?: boolean
}

function Updater() {
  return null
}

const SUBSCRIPTION_TIMEOUT = 300
const UpdaterContainer = withStatusSubscription(SUBSCRIPTION_TIMEOUT)(Updater)

function StatusUpdater({
  projectId,
  buildTypeId,
  subscribeDelayMS,
  updateOverviewParents,
  withoutBranch,
}: Props) {
  const renderTimeout = React.useRef<number>()
  const [isDelayed, setIsDelayed] = React.useState(subscribeDelayMS != null)
  React.useEffect(() => {
    clearTimeout(renderTimeout.current)

    if (isDelayed) {
      renderTimeout.current = window.setTimeout(() => {
        setIsDelayed(false)
      }, subscribeDelayMS)
    }

    return () => clearTimeout(renderTimeout.current)
  }, [subscribeDelayMS, renderTimeout, isDelayed, setIsDelayed])

  if (isDelayed) {
    return null
  }

  return (
    <UpdaterContainer
      projectId={projectId}
      buildTypeId={buildTypeId}
      updateOverviewParents={updateOverviewParents}
      withoutBranch={withoutBranch}
    />
  )
}

export default React.memo<Props>(StatusUpdater)
